import { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { nexaApi, setKey } from './api';

export const PasscodeScreen = ({ onUnlock }) => {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!code || busy) return;
    setBusy(true);
    setError('');
    try {
      await nexaApi.post('/auth', { passcode: code });
      setKey(code);
      onUnlock();
    } catch {
      setError('Wrong passcode');
      setCode('');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[100dvh] flex flex-col items-center justify-center px-8" data-testid="nexa-passcode-screen">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: 'easeOut' }}
        className="w-full max-w-xs flex flex-col items-center"
      >
        <img src="/nexa-logo.png" alt="NEXA" className="w-20 h-20 mb-6 select-none" draggable="false" />
        <h1 className="nexa-heading text-4xl font-light tracking-[0.35em] mb-2">NEXA</h1>
        <p className="text-xs tracking-[0.2em] uppercase text-white/40 mb-12">Personal AI Assistant</p>

        <form onSubmit={submit} className="w-full">
          <input
            type="password"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="Enter passcode"
            autoFocus
            data-testid="nexa-passcode-input"
            className="nexa-input w-full h-14 rounded-2xl px-5 text-center text-lg tracking-widest"
          />
          {error && (
            <motion.p
              initial={{ opacity: 0, x: -8 }}
              animate={{ opacity: 1, x: 0 }}
              className="text-red-400 text-sm text-center mt-3"
              data-testid="nexa-passcode-error"
            >
              {error}
            </motion.p>
          )}
          <motion.button
            whileTap={{ scale: 0.95 }}
            type="submit"
            disabled={busy}
            data-testid="nexa-passcode-submit"
            className="mt-4 w-full h-14 rounded-2xl bg-white text-black font-semibold flex items-center justify-center gap-2 disabled:opacity-50"
          >
            {busy ? 'Unlocking…' : 'Unlock'} {!busy && <ArrowRight className="w-4 h-4" />}
          </motion.button>
        </form>
      </motion.div>
    </div>
  );
};
